export default __webpack_public_path__ + "static/media/Neha_Nikhat.6719640d.pdf";